import gigyaCustomUpdateProfile from './rbmc.profile-update.gigya';
import gigyaRegistrationLogin from './rbmc.registration-login.gigya';
import gigyaLiteRegistration from './rbmc.lite-registration';
import gigyaOidc from './rbmc.oidc';

const gigyaCustom = {
    renderGlobalMessages: msg => {
        let template               = `<div class="global-messages__container">
            <div class="container">
                <div class="row">
                    <div class="offset-lg-1 col-lg-10 offset-md-2 col-md-8 col-sm-12">
                        <div class="global-messages--message-ok">
                            <div class="icon icon-checkmark custom-icon__checkmark-container">
                                <svg class="icon icon-reset custom-icon custom-icon--error">
                                    <use xlink:href="#icon-reset"></use>
                                </svg>
                            </div>
                            <span class="global-messages__text">${msg}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
        let globalMessageContainer = $('.global-messages__container');

        if (globalMessageContainer.length) {
            globalMessageContainer.replaceWith(template);
        } else {
            $('.page-content').prepend(template);
        }
        $('.global-messages__container').addClass('global-messages__newsletter');
    },

    // Prevents implicit optOuts and unconsents on anonymous forms
    clearUncheckedSubscriptions: event => {
        const formData      = event.detail.formModel;
        const subscriptions = formData.subscriptions;

        for (const key in subscriptions) {
            const subscription = subscriptions[key];
            if (subscription.email.isSubscribed === "false" || subscription.email.isSubscribed === false) {
                delete subscriptions[key];
            }
        }
        return formData;
    },

    clearEmailForLoggedIn: evt => {
        if ('detail' in evt) {
            const data     = evt.detail;
            const formData = data.formModel;

            /**
             * Remove email from event object if user is logged in.
             * This will prevent creating multiple email addresses/or replacing current one on CDC account.
             */

            if (window.gigyaUserAuthenticated) {
                delete formData.profile['email'];
            }
            return formData;
        }
    },

    isGigyaUserAuthenticated: () => new Promise((resolve) => window.gigya.accounts.getAccountInfo({
        callback: response => resolve(response.errorCode === 0)
    })),

    showPasswordCheckbox: () => {
        // show password functionality. Also used for change password
        $(document.body).on('change', '.gigya-show-password input', function () {
            let pwdInput       = $('input[name="newPassword"]'),
                pwdInputRetype = $('input[name="passwordRetype"]'),
                oldPwdInput    = $('input[name="password"]');

            if ($(this).prop('checked')) {
                pwdInput.prop('type', 'text');
                pwdInputRetype.prop('type', 'text');
                oldPwdInput.prop('type', 'text');
            } else {
                pwdInput.prop('type', 'password');
                pwdInputRetype.prop('type', 'password');
                oldPwdInput.prop('type', 'password');
            }
        });
    },
    /*
     * Register login events
     */
    gigyaRegister:              () => {
        if (ACC.gigyaUserMode === "raas") {
            gigya.accounts.addEventHandlers({
                onLogin: gigyaHybris.gigyaFunctions.raasLogin
            });
        }
    },
    gigyaCriticalFunctionCalls: () => {
        window.gigyaHybris.gigyaFunctions.raasClick();
        window.gigyaHybris.gigyaFunctions.raasEmbed();
        gigyaCustom.gigyaRegister();
        gigyaOidc.bindHandler();
    },
    gigyaInit:                  async () => {
        //bind forms events
        gigyaRegistrationLogin.bindHandler();
        gigyaCustomUpdateProfile.bindHandler();
        gigyaLiteRegistration.bindHandler();
        window.gigyaUserAuthenticated = await gigyaCustom.isGigyaUserAuthenticated();
        // Critical function calls
        if (window.__gigyaConf) {
            gigyaCustom.gigyaCriticalFunctionCalls();
        } else {
            document.addEventListener('gigyaFunctions-ready', () => {
                gigyaCustom.gigyaCriticalFunctionCalls();
            });
        }
    }
};

$(() => {
    window.gigyaCustom = {
        gigyaInit: gigyaCustom.gigyaInit
    }
    let event          = new Event('gigyaCustom-ready', {bubbles: true});
    document.dispatchEvent(event);
    console.info('Gigya custom ready');
});

export default gigyaCustom;
